import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconPermeabilityMapSizeS from './IconPermeabilityMap_size_s';

const props: CreateIconArguments = {
  l: IconPermeabilityMapSizeS,
  m: IconPermeabilityMapSizeS,
  s: IconPermeabilityMapSizeS,
  xs: IconPermeabilityMapSizeS,
  name: 'IconPermeabilityMap',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
